// AUTO-GENERATED from config/model-tiers.json by scripts/generate-model-tier-docs.mjs.
// DO NOT EDIT BY HAND. Run `node scripts/generate-model-tier-docs.mjs` to regenerate; CI fails on drift.
//
// Frontend model pins MUST come from here — never hand-pin a versioned id (the
// check-tier-allowlist CI gate rejects off-tier literals). Ids are raw OpenRouter format;
// the proxies forward them as-is (they contain a provider segment, so no auto-prefixing).

export const SSOT_VERSION = "2026-09-30b";

/** subagent-default route primary. LEGACY NAME: the constant predates the 2026-07-10
 *  subagent-default move to Tier-2 Mid — it no longer resolves a Tier-1 rung. Kept to
 *  avoid a 10-file consumer rename; treat as 'the default spawn primary' (D1). */
export const TIER1_PRIMARY = "google/gemini-3.8-flash";

/** Planner route primary — engineering planning/architecture (D2 2026-07-11: the planner
 *  route rides the coding-architecture tier; client webchat turns ride 'clarify'). */
export const PLANNER_PRIMARY = "anthropic/claude-opus-5";

/** Thread-label route primary (webchat chip labeling — see services/threadMetadata/inferThreadLabel.ts). */
export const THREAD_LABEL_PRIMARY = "google/gemini-3.8-flash";

// --- Deep-research chain routes (2026-08-15 citation-cutoff fix) ---
// The client desktop deep-research pipeline and the format-report tool pin their
// models from these route-resolved constants instead of hand-written literals, so a
// within-tier swap in config/model-tiers.json reaches the frontend via regeneration.

/** format-report route primary (SSOT: format-report -> tier-1-performance). The deep-research
 *  report formatter (anthropicFormatter.ts) rides THIS rung — never the default-spawn primary. */
export const FORMAT_REPORT_PRIMARY = "anthropic/claude-opus-5.5";

/** deep-research route primary (SSOT: deep-research -> tier-14-deep-research). */
export const DEEP_RESEARCH_PRIMARY = "perplexity/sonar-deep-research";

/** deep-research-qualification route primary (SSOT: -> tier-13-web-search). Client Stage 1
 *  qualification AND the Stage 2 grounded brief ride this web-search rung (the grounded
 *  brief's citations[] feed Stage 3's AUTHORITATIVE_SOURCES — MT-QA-BUG-008). */
export const DEEP_RESEARCH_QUALIFICATION_PRIMARY = "perplexity/sonar-reasoning-pro";

/** Full tier-14 deep-research ladder in rung order (primary first). The client's
 *  Perplexity-down cross-provider fallback chain MUST descend THIS ladder — riding a
 *  different tier's ladder is a misroute per the SSOT preamble. */
export const DEEP_RESEARCH_LADDER = ["perplexity/sonar-deep-research","perplexity/sonar-pro","google/gemini-3.1-pro-preview","x-ai/grok-4.6"];

// --- Document-plane routes (2026-08-22 client misroute fix) ---
// The client translation/document pipeline (translator.ts, claudeDocumentAnalyzer.ts,
// legalDocCreator.ts) pinned TIER1_PRIMARY, which silently became the default-spawn
// primary (x-ai/grok-4.6) — the same drift the 2026-08-15 format-report fix documents.
// SSOT taskRouting pins these tasks to tier-11-document; consume THESE, never TIER1_PRIMARY.

/** translation route primary (SSOT: translation -> tier-11-document). */
export const TRANSLATION_PRIMARY = "anthropic/claude-opus-5";

/** Full translation-route ladder in rung order (primary first). Segmented translation's
 *  per-segment descent MUST ride THIS ladder — not a hand-assembled cross-provider mix. */
export const TRANSLATION_LADDER = ["anthropic/claude-opus-5","x-ai/grok-4.6","moonshotai/kimi-k3","openai/gpt-6-astra"];

/** Per-rung reasoning efforts aligned with TRANSLATION_LADDER indexes — the tier's
 *  rung entry is the authority (a model in several tiers is ambiguous in SSOT_MODEL_EFFORT). */
export const TRANSLATION_LADDER_EFFORTS = ["max","xhigh","max","max"];

/** document-analysis route primary (SSOT: document-analysis -> tier-11-document).
 *  Client document analysis, vision transcription and scanned-page OCR ride this rung. */
export const DOCUMENT_ANALYSIS_PRIMARY = "anthropic/claude-opus-5";

/** Full document-analysis-route ladder in rung order (primary first). */
export const DOCUMENT_ANALYSIS_LADDER = ["anthropic/claude-opus-5","x-ai/grok-4.6","moonshotai/kimi-k3","openai/gpt-6-astra"];

/** legal-doc-creation route primary (SSOT: legal-doc-creation -> tier-11-document). */
export const LEGAL_DOC_CREATION_PRIMARY = "anthropic/claude-opus-5";

// --- SSOT display-time effort fallback (2026-08-16 (Miles): the effort code word
// must ALWAYS display for every model step) ---

/** SSOT-resolved reasoning-effort level per model id (normalized keys: lowercase,
 *  no 'openrouter/' prefix, no '~' sigil; bare after-first-slash forms
 *  included). Mirrors the backend resolver in functions/src/lib/generationUsage.ts
 *  (resolveSsotEffortForModel) — see ssotModelEffortMap in the generator for the
 *  exact resolution rules. Consumed by resolveEffortCodeWordForDisplay
 *  (src/config/providerCodeNames.ts) as the fallback when a stored usage row
 *  carries no effort field. Off-ladder models have NO entry by design. */
export const SSOT_MODEL_EFFORT: Record<string, string> = {
  "anthropic/claude-fable-5.1": "max",
  "anthropic/claude-opus-5": "max",
  "anthropic/claude-opus-5.5": "xhigh",
  "claude-fable-5.1": "max",
  "claude-opus-5": "max",
  "claude-opus-5.5": "xhigh",
  "deepseek-v4-pro": "high",
  "deepseek/deepseek-v4-pro": "high",
  "gemini-3.1-pro-preview": "high",
  "gemini-3.8-flash": "medium",
  "glm-5.3": "max",
  "glm-5.3-flash": "max",
  "google/gemini-3.1-pro-preview": "high",
  "google/gemini-3.8-flash": "medium",
  "gpt-5.6-luna": "max",
  "gpt-5.6-sol": "max",
  "gpt-5.6-terra": "max",
  "gpt-6-astra": "max",
  "gpt-6.1-sol": "low",
  "grok-4.6": "xhigh",
  "grok-4.7": "high",
  "kimi-k3": "max",
  "meta/muse-spark-1.3": "xhigh",
  "moonshotai/kimi-k3": "max",
  "muse-spark-1.3": "xhigh",
  "openai/gpt-5.6-luna": "max",
  "openai/gpt-5.6-sol": "max",
  "openai/gpt-5.6-terra": "max",
  "openai/gpt-6-astra": "max",
  "openai/gpt-6.1-sol": "low",
  "perplexity/sonar-deep-research": "high",
  "perplexity/sonar-reasoning-pro": "high",
  "qwen/qwen3.8-27b": "xhigh",
  "qwen/qwen3.8-flash": "high",
  "qwen/qwen3.8-max-0902": "xhigh",
  "qwen3.8-27b": "xhigh",
  "qwen3.8-flash": "high",
  "qwen3.8-max-0902": "xhigh",
  "sonar-deep-research": "high",
  "sonar-reasoning-pro": "high",
  "x-ai/grok-4.6": "xhigh",
  "x-ai/grok-4.7": "high",
  "z-ai/glm-5.3": "max",
  "z-ai/glm-5.3-flash": "max"
};

// --- Decision routes (2026-08-20 decision-doctrine program) ---

/** Route labels with a decisionContract in the SSOT. The frontend NEVER resolves a model,
 *  ladder, or effort for a decision — it posts { route, messages } to the anthropicProxy
 *  decision mode and the SERVER resolves everything from the registry (stale-CDN-bundle
 *  safety: a tier swap reaches clients without a frontend deploy). Client code may use this
 *  list only to validate a route label before sending. */
export const DECISION_ROUTES: ReadonlyArray<string> = [
  "clarify",
  "clarify-vs-execute",
  "compaction",
  "connect-guide",
  "deep-research-blueprint",
  "deep-research-initial-findings",
  "deep-research-qualification",
  "doc-verify",
  "dr-intake",
  "fast-clarify",
  "greeting-suggestions",
  "legal-niche-classify",
  "memory-consolidation",
  "memory-extraction",
  "memory-hygiene",
  "memory-signal",
  "memory-skill-promotion",
  "message-triage",
  "onboarding-company-research",
  "onboarding-recommendations",
  "parallel-branches",
  "pending-question",
  "planner-classifier",
  "progress-audit",
  "structured-event-narration",
  "task-family",
  "thread-followup-primary",
  "thread-followup-suggestions",
  "thread-label",
  "triage-classify",
  "turn-continuation",
  "turn-lane",
  "turn-research",
  "turn-workflow",
  "widget-document-analysis"
];
